// Fixed ProtectedRoute - no loading state, no redirect loop
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Admin routes - only admins can access
export const AdminRoute: React.FC = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  console.log('AdminRoute: render', { isAuthenticated, isAdmin, isLoading });

  // Show loading state while checking auth
  if (isLoading) {
    console.log('AdminRoute: showing loading state');
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('AdminRoute: not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    console.log('AdminRoute: not admin, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('AdminRoute: allowing access');
  return <Outlet />;
};

// User routes - any authenticated user can access
export const UserRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  console.log('UserRoute: render', { isAuthenticated, isLoading });

  // Show loading state while checking auth
  if (isLoading) {
    console.log('UserRoute: showing loading state');
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('UserRoute: not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  console.log('UserRoute: allowing access');
  return <Outlet />;
};

export default UserRoute;
